import styled from 'styled-components/macro';
import { Scroll } from '../../media-previewer.styled';

export const Table = styled.div`
  width: 100%;
  background: #FFFFFF;
  padding: 16px;
  box-sizing: border-box;
  margin-right: 32px;
  overflow-x: scroll;
  ${Scroll};
  
  table {
    margin-right: 0;
    border-spacing: 10px;
    border-collapse: collapse;
    width: 100%;
    overflow-x: scroll;
    
    tr {
      border: 1px solid #0F1728FF;
    }
    
    th, td {
      border-left: 1px solid #0F1728FF;
      padding: 6px;
      text-align: start;
    }
`;

export const TableContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  box-sizing: border-box;
  background: #FFFFFF;
  color: #0F1728;
  text-align: center;

  i {
    font-size: 32px;
  }

  span {
    max-width: 100%;
    font-size: 12px;
    overflow-wrap: anywhere;
  }
`;

export const Tabs = styled.div`
  position: absolute;
  width: calc(45vw - 32px);
  max-width: 1000px;
  top: 54px;
  display: flex;
  align-items: center;
  gap: 2px;
  overflow: auto;
  white-space: nowrap;
  ${Scroll}
  
  &::-webkit-scrollbar-track {
    margin-top: 2px !important;
  }
  
  div {
    background-color: #FFFFFF;
    padding: 4px;
    border-radius: 30% 30% 0 0;
    box-sizing: border-box;
    cursor: pointer;
  }
`